import React, { useState } from 'react'

import { DQLEditorCollectionsContext } from './context'

type Props = {
  children: React.ReactNode
}

export default function DQLEditorCollectionsProvider({ children }: Props) {
  const [activeCollection, setActiveCollection] = useState<string | undefined>(
    undefined,
  )
  const [collectionCounts, setCollectionCounts] = useState<
    Record<string, number | null>
  >({})

  const [currentPage, setCurrentPage] = useState<number>(1)

  return (
    <DQLEditorCollectionsContext.Provider
      value={{
        activeCollection,
        setActiveCollection,
        collectionCounts,
        setCollectionCounts,
        currentPage,
        setCurrentPage,
      }}
    >
      {children}
    </DQLEditorCollectionsContext.Provider>
  )
}
